module.exports = __webpack_public_path__ + "media/24_Long.bcaa01ee.mp3";